"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_cluster_1 = require("./leaf-cluster");
var Dendrogram = /** @class */ (function () {
    function Dendrogram(cluster, cutOffValue) {
        this.cluster = cluster;
        this.cutOffValue = cutOffValue;
        this.groups = [];
    }
    Dendrogram.prototype.extractClustersAsRefs = function () {
        this.groups = [];
        this.extractClustersRecursively(this.cluster);
        return this.groups.map(function (g) { return g.map(function (c) { return c.object; }); });
    };
    Dendrogram.prototype.extractClustersAsIds = function () {
        this.groups = [];
        this.extractClustersRecursively(this.cluster);
        return this.groups.map(function (g) { return g.map(function (c) { return c.id; }); });
    };
    /**
     * @deprecated
     */
    Dendrogram.prototype.extractClusters = function () {
        return this.extractClustersAsIds();
    };
    Dendrogram.prototype.extractClustersRecursively = function (curr) {
        if (curr instanceof leaf_cluster_1.LeafCluster) {
            this.groups.push(curr.leafClusters());
        }
        else {
            var merged = curr;
            if (merged.distance < this.cutOffValue) {
                this.groups.push(curr.leafClusters());
            }
            else {
                this.extractClustersRecursively(merged.leftChild);
                this.extractClustersRecursively(merged.rightChild);
            }
        }
    };
    return Dendrogram;
}());
exports.Dendrogram = Dendrogram;
